import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { FormDirective } from '../../../directives/form/form.directive';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { FormComponent } from '../../../components/default-form/form.component';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganisationCustomerService } from '@services/customers/organisation-customer.service';

@Component({
    selector: 'app-organisation-customer-edit',
    templateUrl: './organisation-customer-edit.component.html',
    styleUrls: ['./organisation-customer-edit.component.scss'],
    providers: [OrganisationCustomerService],
    standalone: false
})
export class OrganisationCustomerEditComponent implements OnInit {

  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;
  pageActions: PageAction[];

  title = 'Edit Profile';
  create = false;
  isLoading = true;
  boundCustomer: Models.OrganisationCustomer;
  customerId: string;

  constructor(
    private organisationCustomerService: OrganisationCustomerService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private activatedRoute: ActivatedRoute,
    private snackbar: SnackbarService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.customerId = this.activatedRoute.snapshot.params['id'];
    if (this.customerId) {
      this.organisationCustomerService.get(this.customerId).then(response => {
        this.boundCustomer = response;
        this.title = 'Edit customer: ' + this.boundCustomer.organisationName;
        this.isLoading = false;
        this.loadForm();
        this.createPageActions();
      });
    } else {
      this.title = 'Create new organisation customer';
      this.create = true;
      this.boundCustomer = <Models.OrganisationCustomer>Models.ModelFactory.createModelInstanceByName('OrganisationCustomer');
      this.isLoading = false;
      this.loadForm();
    }
  }

  loadForm() {
    const formItem = DefaultFormComponent;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);

    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = this.boundCustomer;
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'info',
        title: 'Detail customer',
        callback: () => {
          this.router.navigate(['organisation-customers', this.activatedRoute.snapshot.params['id']]);
        }
      })
    ];
  }

  onSave() {
    return this.boundCustomer.validate(true).then(result => {
      if (result.success) {
        if (this.customerId) {
          this.organisationCustomerService.update(this.customerId, this.boundCustomer).then(profileResult => {
            console.log(profileResult);
            this.snackbar.success('Successfull updated customer');
          });
        } else {
          this.organisationCustomerService.create(this.boundCustomer).then(profileResult => {
            console.log(profileResult);
            this.snackbar.success('Successfull created new customer');
            this.router.navigate(['organisation-customers']);
          });
        }
      } else {
        this.snackbar.open('Could not create the profile, please fill the form correctly');
      }
    });
  }
}
